"use client"

import { ClockFading } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ClockFadingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ClockFadingIcon = component(Icon)({ as: ClockFading })
